import { Loading } from "@hm/fundamental"
import { ContainerBox } from "@shared/ui"
import React from "react"

export const AuthPage: React.FC = () => {
	return (
		<ContainerBox data-cy="loading-page">
			<Loading size="xlarge" className="block mt-6 mx-auto" />
		</ContainerBox>
	)
}
